/* Verdo x Ceramide product page helpers. Works alongside Dawn's product-info.js and media-gallery.js.
   - keeps the active thumbnail in view in the desktop thumbnail column
   - "Read the full description" opens the Description row
   - <vc-sticky-atc>: add to cart bar on phones, proxying the real Add to cart button
   - flags the buy box being on screen (offers button steps aside) and centres the phone lightbox */
(function () {
  if (window.__vcProductInit) return;
  window.__vcProductInit = true;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Keep the current thumbnail visible when the list scrolls vertically (desktop column) */
  function watchThumbs(root) {
    root.querySelectorAll('[data-vc-thumbs]').forEach((list) => {
      if (list.dataset.vcWatched) return;
      list.dataset.vcWatched = 'true';
      const reveal = () => {
        const current = list.querySelector('[aria-current]');
        if (!current || list.scrollHeight <= list.clientHeight + 2) return;
        const item = current.closest('li') || current;
        const top = item.offsetParent === list ? item.offsetTop : item.offsetTop - list.offsetTop;
        const bottom = top + item.offsetHeight;
        if (top < list.scrollTop) list.scrollTo({ top: top - 4, behavior: reduceMotion() ? 'auto' : 'smooth' });
        else if (bottom > list.scrollTop + list.clientHeight) list.scrollTo({ top: bottom - list.clientHeight + 4, behavior: reduceMotion() ? 'auto' : 'smooth' });
      };
      const hint = () => {
        const scrollable = list.scrollHeight > list.clientHeight + 2;
        list.classList.toggle('is-scrollable', scrollable);
        list.classList.toggle('is-end', !scrollable || list.scrollTop + list.clientHeight >= list.scrollHeight - 4);
      };
      list.addEventListener('scroll', hint, { passive: true });
      window.addEventListener('resize', hint);
      if ('ResizeObserver' in window) new ResizeObserver(hint).observe(list);
      hint();
      new MutationObserver(() => { reveal(); hint(); }).observe(list, { subtree: true, attributes: true, attributeFilter: ['aria-current'], childList: true });
    });
  }

  /* "Read the full description" */
  function wireReadMore(root) {
    root.querySelectorAll('[data-vc-read-more]').forEach((btn) => {
      if (btn.dataset.vcWired) return;
      const scope = btn.closest('product-info') || document;
      const target = scope.querySelector('details[data-vc-desc]');
      if (!target || btn.closest('quick-add-modal')) return;
      btn.dataset.vcWired = 'true';
      btn.hidden = false;
      btn.setAttribute('aria-controls', target.id);
      btn.addEventListener('click', () => {
        target.open = true;
        /* land the row just below the sticky header, which also shrinks while the page scrolls */
        const headerBottom = () => {
          const h = document.querySelector('.vc-header-section');
          if (!h) return 0;
          const pos = getComputedStyle(h).position;
          return pos === 'sticky' || pos === 'fixed' ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
        };
        const offset = () => target.getBoundingClientRect().top - headerBottom() - 16;
        window.scrollBy({ top: offset(), behavior: reduceMotion() ? 'auto' : 'smooth' });
        setTimeout(() => {
          const d = offset();
          if (Math.abs(d) > 4) window.scrollBy({ top: d, behavior: 'auto' });
        }, reduceMotion() ? 60 : 700);
        const summary = target.querySelector('summary');
        if (summary) summary.focus({ preventScroll: true });
      });
    });
  }

  /* Only the slide in view takes focus and is read out; the others stay reachable through the thumbnails.
     Without this, tabbing onto an off-screen slide scrolls the viewer half way between two images. */
  function wireSlides(root) {
    root.querySelectorAll('.vc-gallery__list').forEach((list) => {
      if (list.dataset.vcSlides) return;
      list.dataset.vcSlides = 'true';
      let timer;
      const sync = () => {
        const slides = Array.from(list.children).filter((el) => el.tagName === 'LI');
        if (slides.length < 2) return;
        const x = list.scrollLeft;
        let current = slides[0];
        let best = Infinity;
        slides.forEach((slide) => {
          const d = Math.abs(slide.offsetLeft - x);
          if (d < best) { best = d; current = slide; }
        });
        slides.forEach((slide) => {
          const on = slide === current;
          if (on) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          slide.querySelectorAll('button, a[href], [tabindex]').forEach((el) => {
            if (on) {
              if (el.dataset.vcTab === 'off') { el.removeAttribute('tabindex'); delete el.dataset.vcTab; }
            } else if (el.getAttribute('tabindex') !== '-1') {
              el.setAttribute('tabindex', '-1');
              el.dataset.vcTab = 'off';
            }
          });
        });
      };
      const later = (ms) => { clearTimeout(timer); timer = setTimeout(sync, ms); };
      list.addEventListener('scroll', () => later(120), { passive: true });
      new MutationObserver(() => later(60)).observe(list, { childList: true });
      window.addEventListener('resize', () => later(120));
      sync();
    });
  }

  /* The round offers button (vc-offers) sits in the bottom right corner on phones and tablets. While the buy box is
     on screen it would sit on Add to cart, Buy with Shop or the pickup link, so the page flags that for vc-product.css.
     Main product only: a quick add modal is emptied on close, which would leave the flag stuck. */
  function watchBuyBox(root) {
    if (!('IntersectionObserver' in window)) return;
    root.querySelectorAll('.vc-buy').forEach((box) => {
      if (box.dataset.vcWatched || box.closest('quick-add-modal')) return;
      box.dataset.vcWatched = 'true';
      const html = document.documentElement;
      new IntersectionObserver(([entry]) => {
        html.classList.toggle('vc-pdp-buy-in-view', entry.isIntersecting);
      }, { threshold: 0 }).observe(box);
    });
  }

  /* Phone lightbox: Dawn opens the image zoomed in and centred sideways only, so the shopper first saw the empty
     top of the photo. Centre it both ways once the modal is open. */
  function wireLightbox(root) {
    root.querySelectorAll('product-modal').forEach((modal) => {
      if (modal.dataset.vcCentred) return;
      modal.dataset.vcCentred = 'true';
      new MutationObserver(() => {
        if (!modal.hasAttribute('open')) return;
        requestAnimationFrame(() => {
          const content = modal.querySelector('.product-media-modal__content');
          const active = modal.querySelector('.product-media-modal__content > .active');
          if (!content || !active || window.matchMedia('(min-width: 750px)').matches) return;
          const centre = () => {
            content.scrollTop = Math.max(0, (content.scrollHeight - content.clientHeight) / 2);
            content.scrollLeft = Math.max(0, (content.scrollWidth - content.clientWidth) / 2);
          };
          centre();
          if (active.tagName === 'IMG' && !active.complete) active.addEventListener('load', centre, { once: true });
        });
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
  }

  function init(root) {
    watchThumbs(root);
    wireReadMore(root);
    wireSlides(root);
    watchBuyBox(root);
    wireLightbox(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  /* Variant changes and quick add re-render parts of <product-info> */
  document.addEventListener('product-info:loaded', (e) => init(e.target));
})();

if (!customElements.get('vc-sticky-atc')) {
  customElements.define('vc-sticky-atc', class VcStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this.closest('quick-add-modal')) { this.remove(); return; }
      const section = this.dataset.section;
      this.mainButton = document.getElementById(`ProductSubmitButton-${section}`);
      this.buyBox = this.mainButton ? this.mainButton.closest('.vc-buy') : null;
      this.button = this.querySelector('[data-vc-sticky-btn]');
      this.priceEl = this.querySelector('[data-vc-sticky-price]');
      this.priceSource = document.getElementById(`price-${section}`);
      if (!this.mainButton || !this.buyBox || !this.button) return;

      this.hidden = false;
      this.button.addEventListener('click', () => {
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        this.mainButton.click();
      });

      this.sync = this.sync.bind(this);
      this.buttonObserver = new MutationObserver(this.sync);
      this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
      if (this.priceSource) {
        this.priceObserver = new MutationObserver(this.sync);
        this.priceObserver.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
      }
      this.sync();

      /* Follow the chosen shade, size or infusion: its name next to the price and its image */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const data = event && event.data;
          if (!data || data.sectionId !== section || !data.variant) return;
          this.showVariant(data.variant);
        });
      }

      /* Show as soon as the real Add to cart button has gone up out of sight (off screen or behind the sticky
         header), and step aside while the footer is on screen so the bar never sits over the footer's links
         and newsletter form. Measured on scroll: the header changes height while the page scrolls, which a
         fixed IntersectionObserver margin cannot follow. */
      this.pastBuy = false;
      this.footerIn = false;
      /* The bar is drawn on phones only (vc-product.css). Elsewhere it stays "hidden" too, so that
         html:has(vc-sticky-atc.is-visible) rules, like the offers button lift, do not fire for nothing. */
      this.mq = window.matchMedia('(max-width: 749px)');
      this.onMq = () => this.measure();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      else if (this.mq.addListener) this.mq.addListener(this.onMq);
      this.header = document.querySelector('.vc-header-section');
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => { this.ticking = false; this.measure(); });
      };
      this.footer = document.querySelector('footer.vc-footer') || document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
      if (this.footer) {
        this.fo = new IntersectionObserver(([entry]) => {
          this.footerIn = entry.isIntersecting;
          this.update();
        }, { threshold: 0 });
        this.fo.observe(this.footer);
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      /* answering the cookie banner is a tap, not a scroll: look again just after any tap */
      this.onTap = () => setTimeout(this.onScroll, 400);
      document.addEventListener('click', this.onTap, true);
      this.measure();
    }

    headerBottom() {
      if (!this.header || !this.header.isConnected) this.header = document.querySelector('.vc-header-section');
      if (!this.header) return 0;
      const position = getComputedStyle(this.header).position;
      return position === 'sticky' || position === 'fixed' ? Math.max(0, this.header.getBoundingClientRect().bottom) : 0;
    }

    /* Shopify's cookie banner sits on the bottom of the screen until the shopper answers it: the bar waits */
    cookieBannerUp() {
      const banner = document.getElementById('shopify-pc__banner');
      if (!banner || !banner.getClientRects().length) return false;
      const style = getComputedStyle(banner);
      return style.visibility !== 'hidden' && style.display !== 'none' && parseFloat(style.opacity) > 0.05;
    }

    measure() {
      if (!this.mainButton.isConnected) this.mainButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`) || this.mainButton;
      const rect = this.mainButton.getBoundingClientRect();
      this.pastBuy = rect.height > 0 && rect.bottom < this.headerBottom() + 4;
      this.bannerUp = this.cookieBannerUp();
      this.update();
    }

    update() {
      this.setVisible(this.pastBuy && !this.footerIn && !this.bannerUp && this.mq.matches);
    }

    disconnectedCallback() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      if (this.onTap) document.removeEventListener('click', this.onTap, true);
      this.fo && this.fo.disconnect();
      this.variantUnsubscriber && this.variantUnsubscriber();
      if (this.mq && this.onMq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
      }
      this.buttonObserver && this.buttonObserver.disconnect();
      this.priceObserver && this.priceObserver.disconnect();
      document.documentElement.classList.remove('vc-sticky-atc-on', 'vc-sticky-atc-pad');
    }

    setVisible(show) {
      if (this.shown === show) return;
      this.shown = show;
      this.classList.toggle('is-visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.button.tabIndex = show ? 0 : -1;
      document.documentElement.classList.toggle('vc-sticky-atc-on', show);
      /* Without a footer to watch, keep the end of the page clear of the bar */
      document.documentElement.classList.toggle('vc-sticky-atc-pad', show && !this.footer);
    }

    showVariant(variant) {
      const name = this.querySelector('[data-vc-sticky-variant]');
      if (name && variant.title) name.textContent = variant.title;
      const media = this.querySelector('.vc-sticky-atc__media');
      const img = media && media.querySelector('img');
      if (!img) return;
      const preview = variant.featured_media && variant.featured_media.preview_image;
      let src = preview && preview.src ? preview.src : media.dataset.vcStickyFallback;
      if (!src) return;
      try {
        const url = new URL(src, window.location.href);
        url.searchParams.set('width', '120');
        src = url.toString();
      } catch (e) { /* keep the source as it is */ }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
    }

    sync() {
      const label = this.mainButton.querySelector('span');
      if (label && label.textContent.trim()) this.button.textContent = label.textContent.trim();
      const off = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      this.button.disabled = !!this.mainButton.disabled;
      this.button.classList.toggle('loading', this.mainButton.classList.contains('loading'));
      this.button.setAttribute('aria-disabled', off ? 'true' : 'false');
      if (this.priceEl && this.priceSource) {
        const price = this.priceSource.querySelector('.price--on-sale .price__sale .price-item--sale') ||
          this.priceSource.querySelector('.price__regular .price-item--regular') ||
          this.priceSource.querySelector('.price-item');
        if (price && price.textContent.trim()) this.priceEl.textContent = price.textContent.trim();
      }
    }
  });
}
